import { selectCurrentCustomer, selectCustomersLoaded } from './../../store/search-customers/search-customers.selectors';
import { SearchCustomersState } from './../../store/search-customers/search-customers.reducer';
import { AuthService } from './../../shared/services/auth.service';
import { selectAppointmentsLoaded } from './../../store/bdcdashboard/bdcdashboard.selectors';
import { BdcDashboardState } from './../../store/bdcdashboard/bdcdashboard.reducer';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import * as dashboardActions from '../../store/bdcdashboard/bdcdashboard.actions';
import * as fromSearchCustomersActions from '../../store/search-customers/search-customers.actions';
import { Component, OnDestroy } from '@angular/core';
import { AppointmentType, ICustomer } from '@signal/asp-data-commons';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionList } from '../../shared/models/asp.types';
import * as util from '../../shared/services/util.service';
import { AspBannerService } from '../../shared/services/asp-banner.service';
import { environment } from '../../shared/services/util.service';
import { SettingsState } from '../../store/settings/settings.reducer';
import { LoadSettings } from '../../store/settings/settings.actions';
import { catchError, debounceTime, filter, take } from 'rxjs/operators';
import { DealerState } from '../../store/dealer/dealer.reducer';
import * as fromDealerSelectors from '../../store/dealer/dealer.selectors';
import { TranslateService } from '@ngx-translate/core';
import { ServiceAppointmentState } from '../../store/service-appointment/service-appointment.reducer';
import { SetMakeModelYrPageDefault } from '../../store/service-appointment/service-appointment.actions';
import { VehiclesState } from '../../store/vehicle/vehicle.reducer';
import { LoadAllVehicles } from '../../store/vehicle/vehicle.actions';
import { SourceSystem } from '@signal/asp-data-commons/lib/enums/enum';

@Component({
  selector: 'app-dashboard',
  templateUrl: './bdc-dashboard.component.html',
  styleUrls: ['./bdc-dashboard.component.scss']
})
export class BDCDashboardComponent implements OnDestroy {

  customerIdExists: boolean;
  currentCustomer$: Observable<ICustomer>;
  testDriveType = AppointmentType.TEST_DRIVE;
  deliveryType = AppointmentType.DELIVERY;
  learningType = AppointmentType.LEARNING;
  vehicleInquiryType = AppointmentType.VEHICLE_INQUIRY;
  serviceType = AppointmentType.SERVICE;
  default = "default";
  allApptTypes = "all";
  isAppointmentsLoading$: Observable<boolean>;
  signedIn: boolean = false;
  dealerCode: string;
  subs: SubscriptionList = {};
  showDelivery;
  isLoading$: Observable<boolean>;
  navigateTo: string = '/asp/bdc/customer/search'

  constructor(
    private readonly dashboardState: Store<BdcDashboardState>,
    private readonly customerState: Store<SearchCustomersState>,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly bannerService: AspBannerService,
    private readonly settingsState: Store<SettingsState>,
    private readonly dealerState: Store<DealerState>,
    private readonly translate : TranslateService,
    private readonly serviceAppointmentStore: Store<ServiceAppointmentState>,
    private readonly vehicleState: Store<VehiclesState>,
  ) {
    this.showDelivery = environment.showDelivery;
    this.isLoading$ = this.customerState.select(selectCustomersLoaded);
    this.subs.activatedRoute = this.activatedRoute.queryParams.subscribe(params => {
      if (params.fn && params.ln && params.email && params.customerId) {
        this.customerState.dispatch(new fromSearchCustomersActions.SearchCustomers({
          firstName: params.fn,
          lastName: params.ln,
          query: params.email,
          customerId: Number(params.customerId)
        }));
        this.isLoading$ = this.customerState.select(selectCustomersLoaded);
        this.subs.loading = this.isLoading$.subscribe(isLoaded => {
          if (isLoaded) {
            this.setUpStore();
          }
        })
      }
    })
    if (!(this.router.url.includes('fn') && this.router.url.includes('ln') && this.router.url.includes('email') && this.router.url.includes('customerId'))) {
      this.setUpStore();
    }
  }

  private dispatchActions(customer: ICustomer) {
    let payload: { queryText: string };
    if (this.customerIdExists) {
      payload = {
        queryText: customer.emailAddress ? customer.emailAddress : customer.phoneNumber

      };
      this.dashboardState.dispatch(new dashboardActions.LoadAppointments(payload));
      if (customer.customerId) {
        this.dashboardState.dispatch(new dashboardActions.LoadUserVehicles({ dealerCode: this.dealerCode, customerId: customer.customerId + '' }));
      } else {
        this.dashboardState.dispatch(new dashboardActions.ClearUserVehicles());
      }
    } else {
      this.subs.query = this.activatedRoute.queryParams.subscribe(params => {
        const queryText = params.searchText;
        if (!queryText) {
          this.router.navigate([this.navigateTo]);
        }
        this.dashboardState.dispatch(new dashboardActions.LoadAppointments({ queryText }));
        this.dashboardState.dispatch(new dashboardActions.LoadUserVehicles({ dealerCode: this.dealerCode, customerId: customer.customerId + '' }));
      });
    }
  }

  getCustomerDisplayName(customer: ICustomer): string {
    return util.getCustomerDisplayName(customer);
  }

  setUpStore() {
    this.settingsState.dispatch(new LoadSettings({ department: '' }));
    this.customerIdExists = true;    /* needs update */
    this.currentCustomer$ = this.customerState.select(selectCurrentCustomer);
    this.vehicleState.dispatch(new LoadAllVehicles({ view: SourceSystem.ME }));
    this.subs.auth = this.authService.getDealerId().subscribe(dealerCode => {
      this.dealerCode = dealerCode;
      this.subs.customer = this.currentCustomer$
        .pipe(
          debounceTime(1000),
          take(1),
          catchError(error => {
            console.warn('error occured while finding a valid customer:', error);
            this.router.navigate([this.navigateTo]);
            return of(null);
          })
        ).subscribe(t => {
          if (t) {
            this.dispatchActions(t);
            this.isAppointmentsLoading$ = this.dashboardState.select(selectAppointmentsLoaded);
            this.bannerService.hideCarImage();
          }
          else {
            this.router.navigate([this.navigateTo])
          }
        });
    });
    this.dealerState.select(fromDealerSelectors.dealerDetails).pipe(
      filter(dealerDetails => dealerDetails.data !== null && dealerDetails.data !== undefined),
      take(1)
    ).subscribe(dealerData => {
      if (dealerData.data?.isSalesAccessibleFeatureFlag === false && dealerData.data?.isServiceAccessibleFeatureFlag === false && dealerData.data?.isSpServiceDashboardOverride === false) {
        this.router.parseUrl('/asp/deliveryChecklist/summary');
      }
    });
  }

  isEnableSection(type: string) {
    if (type === 'service') {
      return !util.isServiceAccessibleFeatureFlag ? !!util.isSpServiceDashboardOverride : true;
    }
    else if (type === 'sales') {
      return !!util.isSalesAccessibleFeatureFlag;
    }
    else {
      return true;
    }
  }


  isButtonDisable() {
    return !util.isServiceAccessibleFeatureFlag ?  !!util.isSpServiceDashboardOverride : false;
  }

  onNewAppointmentClick() {
    this.serviceAppointmentStore.dispatch(new SetMakeModelYrPageDefault());
    this.router.navigate(['/asp/bdc/service']);
  }

  isNotServiceAccessible() {
      return !util.isServiceAccessibleFeatureFlag && !util.isSpServiceDashboardOverride;
  }

  getNewAppointmentTxt(): string {
    return this.translate.instant('testDrive.selectDifferentVehicle');
  }

  ngOnDestroy() {
    util.unsubscribeSubscriptions(this.subs);
    this.bannerService.showCarImage();
  }
}
